module.exports = __webpack_public_path__ + "static/salt2-067c25a50c5ea01e3359d18e93efdbae.png";